import { HttpClient } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Observable, Subscription, catchError, switchMap, tap, throwError, timer } from 'rxjs';
import { ApiService } from './apiService';
import jwt_decode from "jwt-decode";

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http:HttpClient,private cookieService: CookieService,private inject: Injector) {

  }

  private apiUrl = 'https://stagingapp.govnet.gov.jo/api';
  private nextCallTimeKey = 'next_api_call_time';

  

  login(email: string, password: string): Observable<any> {
    const url = `${this.apiUrl}/api/user/login`;
    const body = { email, password };
    return this.http.post<any>(url, body);
  }

  initTokenFromUrl(): void {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get('token');

    if (token) {
      this.setToken(token);

      // remove token from URL
      window.history.replaceState({}, document.title, window.location.pathname);
    }
  }

  getToken(): string | null {
    return this.cookieService.get('token');
  }

  getAccessToken(): string | null {
    return this.cookieService.get('access_token');
  }

  getRefreshToken(): string | null {
    return this.cookieService.get('refresh_token');
  }

  getRole(): string[] | null {

    var token = this.getToken()!;

    if(token){
      var decoded = jwt_decode(token) as any;

      return decoded.role ??[];
    }else{
      return [];
    }
    
  }

  getNationalNumber(): string | null {

    // var token = this.getToken()!;

    // var decoded = jwt_decode(token) as any;

    // return decoded.name;

    return this.cookieService.get('nationalNumber');
  }

  // getNationalPass(): string | null {
  //   return this.cookieService.get('nationalPass');
  // }

  setToken(token: string): void {
    this.cookieService.set('token', token,1,'/');
  }

  setAccessToken(token: string): void {
    this.cookieService.set('access_token', token,1,'/');
  }

  setRole(role: string): void {
    this.cookieService.set('role', role ,1,'/');
  }

  setRefreshToken(token: string): void {
    this.cookieService.set('refresh_token', token,1,'/');
  }

  setNationalNumber(natNumber: string): void {
    this.cookieService.set('nationalNumber', natNumber,1,'/');
  }

  //   setNationalPass(pass: string): void {
  //   this.cookieService.set('nationalPass', pass,1,'/');
  // }

  removeToken(): void {
    this.cookieService.delete('token','/');
    this.cookieService.delete('refresh_token','/');
    this.cookieService.delete('nationalNumber','/');
    this.cookieService.delete('nationalPass','/');
    this.cookieService.delete('access_token','/');
    this.cookieService.delete('role','/');
    localStorage.removeItem(this.nextCallTimeKey);
  }

  removeToken2(): void {
    this.cookieService.delete('token','/');
    this.cookieService.delete('access_token','/');
    this.cookieService.delete('refresh_token','/');
  }

}
